module.exports = __webpack_public_path__ + "img/reward-points.404e426b.png";